import React from 'react';
import {
  YouTube as YouTubeIcon,
  Language as WebIcon,
  X as XIcon,
  Instagram as InstagramIcon,
  Facebook as FacebookIcon,
  LinkedIn as LinkedInIcon,
  MusicNote as TikTokIcon,
  Newspaper as NewspaperIcon,
  MenuBook as MagazineIcon,
  Tv as TvIcon,
  Radio as RadioIcon,
  Podcasts as PodcastIcon
} from '@mui/icons-material';

const PinterestIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" {...props}>
    <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" />
  </svg>
);

const CustomThreadsIcon = (props) => (
  <svg viewBox="0 0 192 192" width="1em" height="1em" fill="currentColor" {...props}>
    <path d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z" />
  </svg>
);

export const sentimentOptions = [
  { value: 'positive', label: 'Positivo' },
  { value: 'neutral', label: 'Neutro' },
  { value: 'negative', label: 'Negativo' }
];

export const exposureOptions = [
  { value: 'dedicated', label: 'Dedicada' },
  { value: 'shared', label: 'Compartilhada' },
  { value: 'mention', label: 'Citação' },
  { value: 'none', label: 'Sem exposição' }
];

export const mediaTypeOptions = [
  { value: 'Online', label: 'Online', icon: <WebIcon sx={{ fontSize: 18 }} /> },
  { value: 'YouTube', label: 'YouTube', icon: <YouTubeIcon sx={{ fontSize: 18 }} /> },
  { value: 'Twitter', label: 'Twitter/X', icon: <XIcon sx={{ fontSize: 18 }} /> },
  { value: 'Instagram', label: 'Instagram', icon: <InstagramIcon sx={{ fontSize: 18 }} /> },
  { value: 'Threads', label: 'Threads', icon: <CustomThreadsIcon style={{ fontSize: 18 }} /> },
  { value: 'TikTok', label: 'TikTok', icon: <TikTokIcon sx={{ fontSize: 18 }} /> },
  { value: 'Facebook', label: 'Facebook', icon: <FacebookIcon sx={{ fontSize: 18 }} /> },
  { value: 'LinkedIn', label: 'LinkedIn', icon: <LinkedInIcon sx={{ fontSize: 18 }} /> },
  { value: 'Pinterest', label: 'Pinterest', icon: <PinterestIcon style={{ fontSize: 18 }} /> },
  { value: 'Jornal', label: 'Jornal', icon: <NewspaperIcon sx={{ fontSize: 18 }} /> },
  { value: 'Revista', label: 'Revista', icon: <MagazineIcon sx={{ fontSize: 18 }} /> },
  { value: 'TV', label: 'TV', icon: <TvIcon sx={{ fontSize: 18 }} /> },
  { value: 'Radio', label: 'Rádio', icon: <RadioIcon sx={{ fontSize: 18 }} /> },
  { value: 'Podcast', label: 'Podcast', icon: <PodcastIcon sx={{ fontSize: 18 }} /> }
];

export const contentTypeOptions = [
  { value: 'article', label: 'Artigo' },
  { value: 'video', label: 'Vídeo' },
  { value: 'short', label: 'Short' },
  { value: 'reel', label: 'Reel' },
  { value: 'story', label: 'Stories' },
  { value: 'post', label: 'Post' },
  { value: 'pin', label: 'Pin' }
];

export const tierOptions = [
  { value: 'tier1', label: '1' },
  { value: 'tier2', label: '2' },
  { value: 'tier3', label: '3' }
];

export const statusOptions = [
  { value: 'unread', label: 'Nao lidos' },
  { value: 'read', label: 'Lidos' },
  { value: 'favorite', label: 'Favoritos' },
  { value: 'not_favorite', label: 'Nao favoritos' },
  { value: 'no_tags', label: 'Sem tags' },
  { value: 'with_tags', label: 'Com tags' },
  { value: 'with_image', label: 'Com imagem' },
  { value: 'without_image', label: 'Sem imagem' },
  { value: 'kpia_applied', label: 'Com analise IA' },
  { value: 'kpia_pending', label: 'Sem analise IA' },
  { value: 'editorial_pending', label: 'Area editorial pendente' },
  { value: 'editorial_complete', label: 'Com area editorial' }
];

export const dateOptions = [
  { value: 'last_day', label: 'Último dia' },
  { value: 'last_week', label: 'Última semana' },
  { value: 'last_month', label: 'Último mês' },
  { value: 'custom', label: 'Personalizado' }
];

export const collectionOptions = [
  { value: 'favoritos', label: 'Favoritos' },
  { value: 'leitura', label: 'Leitura' }
];

export const sortOptions = [
  { value: 'date_desc', label: 'Publicação Recente' },
  { value: 'date_asc', label: 'Publicação Antiga' },
  { value: 'created_desc', label: 'Cadastro Recente' },
  { value: 'created_asc', label: 'Cadastro Antigo' },
  { value: 'valuation_desc', label: 'Maior Valoração' },
  { value: 'valuation_asc', label: 'Menor Valoração' },
  { value: 'tier_asc', label: 'Tier 1 Primeiro' },
  { value: 'tier_desc', label: 'Tier 3 Primeiro' },
  { value: 'title_az', label: 'Título A-Z' },
  { value: 'title_za', label: 'Título Z-A' },
  { value: 'source_az', label: 'Fonte A-Z' },
  { value: 'source_za', label: 'Fonte Z-A' }
];
